import { combineReducers } from "@reduxjs/toolkit";
import { session } from "./session";

const reducers = combineReducers({
	session,
});

export default reducers;
